module.exports = __webpack_public_path__ + "img/wl.3afcd73e.jpg";